// extracted by mini-css-extract-plugin
module.exports = {"badge":"agreement_visits_badge__2xs3O","popover":"agreement_visits_popover__1JmUf","list":"agreement_visits_list__2iu2T","item":"agreement_visits_item__3QHP2"};